import React, { useState, useEffect } from "react";
import axios from "axios";
import "../App.css";

interface WeatherData {
  temperature: number;
  tempFeelsLike: number;
  description: string;
}

const WeatherComp: React.FC = () => {
  const [weather, setWeather] = useState<WeatherData | null>(null);

  const urlApi = "https://analyse-feed-holub.onrender.com";

  //eff
  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const apiUrl = urlApi;
        if (!apiUrl) {
          throw new Error("API URL není definováno");
        }

        const response = await axios.get(apiUrl + "/weather");
        const data = response.data;

        setWeather({
          temperature: data.temperature,
          tempFeelsLike: data.tempFeelsLike,
          description: data.description,
        });
      } catch (error) {
        console.error("Chyba při získávání počasí:", error);
      }
    };
    fetchWeather();
  }, []);

  return (
    <div>
      {weather ? (
        <div className="weather">
          <p>
            Teplota: {weather.temperature.toLocaleString("cs-CZ")} °C,{" "}
            {weather.description}{" "}
          </p>
          <p>
            Pocitová teplota: {weather.tempFeelsLike.toLocaleString("cs-CZ")} °C
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default WeatherComp;
